import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import DataActions from '../redux/dataRedux'
import { makeGetEventData } from '../selectors/eventDataSelector'
import { SENTINEL_KEY } from '../config/constants'
import getDateFromTimeIso from '../utility/getDateFromTimeIso'

const datetimeToMosaicId = datetime => {
  if (!datetime) {
    return null
  }

  const date = new Date(datetime)
  const month = ('0' + date.getMonth()).slice(-2)
  const year = date.getFullYear()

  const mosaicId = `global_monthly_${year}_${month}_mosaic`

  return mosaicId
}

const SENTINEL1 = ({ mosaicId='global_monthly_2018_09_mosaic' }) =>
      `https://tiles.planet.com/basemaps/v1/planet-tiles/${mosaicId}/gmap/{z}/{x}/{y}.png?api_key=c93217084d874198991837b45be28f49`
// https://tiles.planet.com/basemaps/v1/planet-tiles/global_monthly_18_06_mosaic/gmap/10/272/364.png?api_key=c93217084d874198991837b45be28f49

const id = 'PlanetMosaic'
const authId = 'Sentinel'
const datetimeId = 'PlanetMosaic'
const SOURCE_URL = SENTINEL1

const layout = {
  'line-cap': 'round'
}

export class Sentinel2Raster extends Component {
  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions, hovered } = this.props
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { idToken, layerRendered, paint, time } = this.props

    const visible = layerRendered

    const mosaicId = datetimeToMosaicId(time)
    const before = 'default'
    const timeIso = time ? new Date(time).toISOString() : ''
    const timeIso2 = time ? new Date(time + 604800000).toISOString() : ''

    const rasterSource = {
      type: 'raster',
      tiles: [SOURCE_URL({ mosaicId })],
      tileSize: 512
    }

    if (!visible || !mosaicId) {
      return null
    }

    return (
      <div>
        <Source
          id={id}
          tileJsonSource={rasterSource}
          />,
      <Layer
        type='raster'
        id={id}
        sourceId={id}
        paint={paint}
        before={before}
        />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const getDatetime = makeGetDatetime()
  const getEventData = makeGetEventData()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(
        state,
        id,
        authId
      ),
      paint: getPaint(state, id),
      time: state.layer.times[datetimeId] || undefined,
      datetime: getDatetime(state, id) || '',
      hovered: getEventData(state, id)
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      dataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, id, event))
    }
  }
}

export default connect(makeMapStateToProps(), mapDispatchToProps)(Sentinel2Raster)



// WEBPACK FOOTER //
// ./src/layers/PlanetMosaic.js